// @i18n-ignore-file
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable i18next/no-literal-string */
// Ignoring this as this is specific english error page

import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import { useOnPageError } from '@src/modules/client-reload'
import { Link } from '@src/quince-components/src'

import useDeviceInfo, { DEVICE_TYPES } from '../../../../../hooks/useDeviceInfo'
import Header from '../../header'

import styles from './errorPage.module.scss'

function SomethingWentWrongPageEnglish({ showHeader = true, children }: PropsWithChildren<{ showHeader?: boolean }>) {
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  useOnPageError()
  return (
    <React.Fragment>
      {showHeader && <Header primaryMenus={[]} secondaryMenus={[]} isErrorPage={true} skipSearchTranslation />}
      <div className={classNames(styles.errorContent, { [styles.baseErrorContent || '']: !showHeader })}>
        <div>
          <h1>IT’S NOT YOU, IT’S US.</h1>
          <p>
            {isMobile ? (
              <>Looks like something is wrong on our end. Please go back and try again or go to our homepage.</>
            ) : (
              <>
                Looks like something is wrong on our end.
                <br />
                Please go back and try again or go to our homepage.
              </>
            )}
          </p>
        </div>

        <Link href="/">
          <button>go to homepage</button>
        </Link>
        {children ? <div>{children}</div> : null}
      </div>
    </React.Fragment>
  )
}

export default SomethingWentWrongPageEnglish
